import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Breadcrumbs } from '@/components/layout/Breadcrumbs';
import { PageContainer } from '@/components/layout/PageContainer';
import { BackButton } from '@/components/composite/buttons/BackButton';
import { PickemGameRulesTab } from '@/components/pickems/PickemGameRulesTab';

export const Route = createFileRoute('/dashboard/pickems/settings')({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      tab: search.tab as 'game-rules' | undefined,
    };
  },
  component: PickemSettingsPage,
});

function PickemSettingsPage() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const activeTab = search.tab || 'game-rules';

  return (
    <PageContainer>
      <Breadcrumbs overrides={{ pickems: "Pick'em", settings: 'Settings' }} />

      <div className="flex items-center gap-4 mb-6">
        <BackButton />
        <h1 className="text-2xl font-semibold">Pick'em Settings</h1>
      </div>

      <Tabs
        value={activeTab}
        onValueChange={value =>
          navigate({
            to: '/dashboard/pickems/settings',
            search: { tab: value as 'game-rules' },
          })
        }
        className="w-full"
      >
        <TabsList className="grid w-full grid-cols-1">
          <TabsTrigger value="game-rules">Game Rules</TabsTrigger>
        </TabsList>

        <TabsContent value="game-rules" className="space-y-4">
          <PickemGameRulesTab />
        </TabsContent>
      </Tabs>
    </PageContainer>
  );
}
